import { render, staticRenderFns } from "./item_modal.vue?vue&type=template&id=4229f54a&"
import script from "./item_modal.vue?vue&type=script&lang=js&"
export * from "./item_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports